import { Component, HostListener, OnInit, OnDestroy } from '@angular/core';
import { HeaderComponent } from './header.component';
import { ActivatedRoute, Router } from '@angular/router';
import { Event } from '@angular/router';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromStore from '../../../store';
// import * as UserActions from '../../../store/actions/user.actions';
import { takeWhile } from 'rxjs/operators';

@Component({
	selector: 'app-header',
	templateUrl: './header.indra.component.html',
	styleUrls: ['./header.component.scss']
})

export class INDRAHeaderComponent extends HeaderComponent implements OnInit, OnDestroy {
	isAlive = true;
	screenWidth: any;
	mobileMediaQuerieSize = 1025;
	showHeader: 'mobile' | 'desktop';
	showFallback: boolean = false;
	isLoading: boolean = true;
	isLandingPage = false;

	// urlQueryParamsRead: boolean = false;

	transparentHeaderRoutes = [
		'/my-bookings',
		'/my-bookings/details',
		'/my-bookings/view',
		'/dummypage'
	];

	transparentDesktopHeaderRoutes = [
		'/booking',
		'/corporate'
	];

	// private fallback_header$: Observable<boolean> = this.store.select(fromStore.getFallbackHeader);
	private user_loading$: Observable<boolean> = this.store.select(fromStore.getUserLoading);
	confirmDialog$: Observable<boolean> = this.store.select(fromStore.getConfirmDialog);

	current_page$: Observable<any> = this.store.select(fromStore.getSelectedBookingCurrentPage);

	constructor(private router: Router, private route: ActivatedRoute, private store: Store<fromStore.State>) {
		super();
		this.getScreenSize();

		this.router.events.subscribe((event: Event) => {
			this.getHeaderStyles();
		});

		this.current_page$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe(value => {

				this.isLandingPage = value == null;

				if (value != null)
					document.querySelector('header').classList.add('not-landing');
				else
					document.querySelector('header').classList.remove('not-landing');
			});
	}

	ngOnInit() {
		this.user_loading$.pipe(takeWhile(() => this.isAlive)).subscribe(value => {
			this.isLoading = value;
		});
	}

	ngOnDestroy() {
		this.isAlive = false;
	}

	getHeaderStyles() {
		const routerTree = this.router.parseUrl(this.router.url);
		const queryParams = routerTree.queryParams;
		
		routerTree.queryParams = {};
		let forceTransparentHeader = false;

		let routeUrl = routerTree.toString();

		if (routeUrl.includes('/my-bookings/details/')) {
			routeUrl = '/my-bookings/details';
		}
		
		if (routeUrl.includes('/my-bookings/view/')) {
			if (queryParams.notification === 'purchase-completed' || queryParams.notification === 'time-to-think') {
				forceTransparentHeader = true;
			}
		}

		const body = document.getElementsByTagName('body')[0];
		if (this.transparentHeaderRoutes.filter((route) => routeUrl === route).length > 0 || forceTransparentHeader) {
			body.classList.add('mod-hp');
		} else {
			body.classList.remove('mod-hp');
		}

		if (this.transparentDesktopHeaderRoutes.filter((route) => routeUrl === route).length > 0) {
			body.classList.add('mod-hp--dekstop-only');
			if (this.showHeader === 'desktop') {
				body.classList.add('mod-hp');
			}
		} else {
			body.classList.remove('mod-hp--dekstop-only');
		}
		
		// Corporate
		if (routeUrl.includes('/corporate')) {
			body.classList.add('is-corporate');
		} else {
			body.classList.remove('is-corporate');
		}
	}

	@HostListener('window:resize', ['$event'])
	getScreenSize(event?) {
		this.screenWidth = window.innerWidth;
		if (this.screenWidth < this.mobileMediaQuerieSize) {
			this.showHeader = 'mobile';
		} else {
			this.showHeader = 'desktop';
		}
		this.getHeaderStyles();
	}

}
